import { Button, FormControl, InputGroup, ListGroup, Container, Row, Col, Image, Accordion, Card, Table } from "react-bootstrap";
import { useEffect, useState, useContext } from "react";
import deleteIcon from "../../../assets/delete.png";
import editIcon from "../../../assets/editing.png";
import Icon from "../../generic/Icon";
import ModalConfirmation from "../../modal_confirmacion";
// jquery
import $ from "jquery";
import { callAjaxGet } from "../../../utils";

import styled from "styled-components";
import { dateToString2 } from "../../../utils";


import GenericTable from "../../generic/GenericTable";
import { AgregarExterno } from "./AgregarExterno";
import { ModalContext } from "../../../context/modalContext";
import { putExtern, postExtern } from "../../../services/usuario/usuario";
import MisionExtraForm from "../../hermana/formularios/MisionExtraForm";

import { AlertBoxContext } from "../../../context/alertBoxContext";
import { ConfirmModalContext } from "../../../context/confirmModalContext";


const CustomTdo = styled.td`
  background-color: #eeeeee;
`;
const CustomTdc = styled.td`
  background-color: #F8F9FA;
`;
const CustomTdoo = styled.td`
  background-color: #dddddd;
`;
const CustomTro = styled.tr`
  background-color: #eeeeee;
`;
const CustomTrc = styled.tr`
  background-color: #F8F9FA;
`;


// Buscador y lista de los externos de cada organizacion
const ListaMisionLocalHermanas = ({ accessLevel = 8 }) => {

// Ventana de confirmación
const { confirmModalSetShow, confirmModalSetTitle, confirmModalSetContent, confirmModalSetFunction } = useContext(ConfirmModalContext);
    
    const [externos, setExternos] = useState([]);
    const [searchValue, setSearchValue] = useState("");

    const [mostrarModal, setMostrarModal] = useState();
    const [aBorrar, setABorrar] = useState();

    // Custom spinner
    const [loading, setLoading] = useState(false);
    // Alertas
    const { addAlert } = useContext(AlertBoxContext);

    const getMisionLocalHermanas = async (errorHandling, filtro) => {
        console.log(`${process.env.REACT_APP_API_URL}/misionextraall${filtro ? `?findName=${filtro}` : ''}`)
        return (await callAjaxGet("GET", `${process.env.REACT_APP_API_URL}/misionextraall${filtro ? `?findName=${filtro}` : ''}`,
            errorHandling));
    }


    //------------------------------------------------ POST -------------------------------------------------------
    // Añade una misión extra
    const postMisionExtra = (data) => {
      //console.log('dataaaaaaaaaaaaaaaaa')
      //console.log(data)
      let settings = {
        url: `${process.env.REACT_APP_API_URL}/usuarios/${data.userId}/misionextra`,
        method: "POST",
        xhrFields: {
          withCredentials: true,
        },
        data: data,
      };
      return $.ajax(settings);
    };
  
    //------------------------------------------------ PUT -------------------------------------------------------
    // Actualiza misión extra
    const putMisionExtra = (data) => {
      let settings = {
        url: `${process.env.REACT_APP_API_URL}/usuarios/${data.userId}/misionextra/${data.id}`,
        method: "PUT",
        xhrFields: {
          withCredentials: true,
        },
        data: data,
      };
      return $.ajax(settings);
    };
  
    //------------------------------------------------ DELETE -------------------------------------------------------
    // Elimiina misión extra
    const delMisionExtra = (data) => {
      let settings = {
        url: `${process.env.REACT_APP_API_URL}/usuarios/${data.userId}/misionextra/${data.id}`,
        method: "DELETE",
        xhrFields: {
          withCredentials: true,
        },
        data: data,
      };
      return $.ajax(settings);
    };
  
    //********************************************** HANDLERS ****************************************************/
    // Manejador para las misiones extra
    
    const handlePostMisionExtra = (data) => {
      modalSetShow(false);
      setLoading(true);
      postMisionExtra(data)
        .then((response) => {
          setLoading(false);
          fn();
          addAlert("Éxito", "Se ha añadido la misión correctamente", "success");
        })
        .catch(() => {
          setLoading(false);
          addAlert("Error", "Error al añadir la misión de la hermana", "danger");
        });
    };
  
    const handlePutMisionExtra = (data) => {
      //console.log('data handle put')
      //console.log(data)
      modalSetShow(false);
      setLoading(true);
      putMisionExtra(data)
        .then((response) => {
            fn();
          setLoading(false);
          addAlert("Éxito", "Se ha actualizado la misión correctamente", "success");
        })
        .catch(() => {
          setLoading(false);
          addAlert("Error", "Error al actualizar la misión de la hermana", "danger");
        });
    };
  
    const handleDeleteMisionExtra = (data) => {
      modalSetShow(false);
      setLoading(true);
      delMisionExtra(data)
        .then((response) => {
            fn();
          setLoading(false);
          addAlert("Éxito", "Se ha eliminado la misión correctamente", "success");
        })
        .catch(() => {
          setLoading(false);
          addAlert("Error", "Error al eliminar la misión de la hermana", "danger");
        });
    };
  

    const fn = async () => {
        setExternos(await getMisionLocalHermanas(null, searchValue ? searchValue : null));
    };

    //102022
    // Contexto para modal de formularios
    const { modalSetShow, modalSetTitle, modalSetContent } = useContext(ModalContext);

    useEffect(() => {
        fn()
    }
        , [searchValue])

    const manejaModal = (id) => {
        setMostrarModal(!mostrarModal)
        setABorrar(id)
    }

    

    return (
        <>
            <InputGroup className={"py-2"}>
                <FormControl type="text" placeholder="Buscar hermana en la misión" value={searchValue}
                    onChange={e => setSearchValue(e.target.value)} />
                
                <Button
                variant="outline-primary"
                size="sm"
                className="float-right mr-4"
                onClick={() => {
                  modalSetShow(true, "60%");
                  modalSetTitle("Añadir hermana a la misión");
                  modalSetContent(<MisionExtraForm submissionHandler={handlePostMisionExtra} />);
                }}
              >
                    Añadir hermana a la misión
              </Button>
              
            </InputGroup>

            <Container>
                <GenericTable>
                    <thead>
                        <th>Foto</th>
                        <th>Nombre</th>
                        <th>Apellido 1</th>
                        <th>Apellido 2</th>

                    </thead>
                    <tbody>
                        {externos?.items && externos.items.map(e =>
                            <>
                                <CustomTro >
                                    <td rowSpan={2} className="col-1"><Image height={'72px'} src={e.photo ? `${process.env.REACT_APP_API_URL}/download/usuarios/${e.id}` : "images/nun.png"} /></td>
                                    <td className="col-2"><b>{e.name}</b></td>
                                    <td className="col-3"><b>{e.firstSurname}</b></td>
                                    <td className="col-4"><b>{e.secondSurname ? e.secondSurname : ""}</b></td>
                                </CustomTro>

                                <CustomTro>
                                    <td colSpan={3}>
                                        {e.email ? e.email : ""}
                                    </td>
                                </CustomTro>

                                <CustomTrc>
                                    <CustomTdc colSpan={4}>
                                        <Accordion>
                                            <Accordion.Toggle eventKey="0" as={Button} variant="link">
                                                Detalle de misión de la hermana
                                            </Accordion.Toggle>

                                            <Accordion.Collapse eventKey="0">

                                                <Card.Body>
                                                    <Table bordered responsive>
                                                        <tbody>
                                                            {e.cargosextras && e.cargosextras.map(i =>
                                                                <>
                                                                    <tr>
                                                                        <CustomTdoo colSpan={3}><b>{i.mission ? `${i.mission.name} - ${i.cargo}` : i.cargo}</b></CustomTdoo>
                                                                        <td>{accessLevel > 2 && (
              <Button
                onClick={() => {
                  confirmModalSetShow(true);
                  confirmModalSetTitle(`Eliminar misión de la hermana (${i.cargo})`);
                  confirmModalSetContent(<p> {"¿Está seguro de que quiere eliminarla?"} </p>);
                  confirmModalSetFunction(() => {
                    handleDeleteMisionExtra(i);
                  });
                }}
                variant="outline-danger"
                size="sm"
                className="float-right mr-4"
              >
                Eliminar
              </Button>
            )}
            {(i?.endDate === null || dateToString2(new Date(i?.endDate)) > dateToString2(new Date())) && accessLevel > 2 && (
              <Button
                variant="outline-primary"
                size="sm"
                className="float-right mr-3"
                onClick={() => {
                  modalSetShow(true, "80%");
                  modalSetTitle("Editar misión de la hermana");
                  modalSetContent(<MisionExtraForm  misionExtra={i} submissionHandler={handlePutMisionExtra} />);
                }}
              >
                Editar
              </Button>
            )}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <CustomTdo >
                                                                            <span>Lugar</span>
                                                                        </CustomTdo>

                                                                        <td >{i.lugar || <small>No especificado</small>}</td>

                                                                        <CustomTdo>
                                                                            <span>Nivel</span>
                                                                        </CustomTdo>

                                                                        <td >{i.nivel || <small>No especificado</small>}</td>
                                                                    </tr>

                                                                    <tr><td colSpan={4}>{'Descripción de misión: '+i.descripcion }</td></tr>
                                                                    <tr>
                                                                        <CustomTdo >
                                                                            <span>F. Inicio</span>
                                                                        </CustomTdo>

                                                                        <td >{i.startDate || <small>No especificado</small>}</td>

                                                                        <CustomTdo>
                                                                            <span>F. Fin</span>
                                                                        </CustomTdo>

                                                                        <td >{i.endDate || <small>No especificado</small>}</td>
                                                                    </tr>

                                                                    {i.mission && <tr><td colSpan={4}>{i.mission ? `Descripción ${i.lugar}: ${i.mission.description}` : ''}</td></tr>}
                                                                    <tr><CustomTdc colSpan={4}><hr></hr></CustomTdc></tr>
                                                                </>
                                                            )}
                                                        </tbody>

                                                    </Table>
                                                </Card.Body>
                                            </Accordion.Collapse >
                                        </Accordion>
                                    </CustomTdc>
                                </CustomTrc>
                            </>
                        )}
                    </tbody>
                </GenericTable>

                <ModalConfirmation
                    texto={"¿Está seguro de que quiere eliminarlo? No podrá deshacer esta acción"}
                    show={mostrarModal}
                    handleButtonShow={manejaModal}
                    deleteFunction={() => handleDeleteMisionExtra(aBorrar)}
                />
                <Row className="mt-2"></Row>
            </Container>
        </>
    )
};

export default ListaMisionLocalHermanas;